// Полуоткрытые диапазоны: верхней границы нет, каждый следующий начинается там, где
// заканчивается предыдущий. Так между брейкпоинтами не остаётся дыр на дробных ширинах.
// Нижний бакет начинается с 0: при зуме ≥400% ширина уходит ниже 320px, и прежний пол
// в 320px оставлял экран вообще без подходящего диапазона (а CSS — без миксина).
const RESOLUTION_STEPS = [
  { name: 'mobile_small', from: 0 },
  { name: 'mobile_big', from: 480 },
  { name: 'tablet', from: 721 },
  { name: 'desktop_small', from: 1024 },
  { name: 'desktop_big', from: 1280 },
  { name: 'hd', from: 1600 },
] as const;

export type TResolutionName = (typeof RESOLUTION_STEPS)[number]['name'];

/**
 * Имя диапазона по ширине окна.
 *
 * Границы обязаны совпадать с миксинами в `shared/src/styles/mixins/mixins.css`.
 * Остаточное расхождение: `window.innerWidth` по спецификации целое, а media query видит
 * дробную ширину, поэтому на ширинах вида 720.5px CSS и JS могут разойтись в пределах
 * одного пикселя. Полное устранение требует перевода JS на matchMedia — отдельная задача.
 */
export function getResolution(width?: number): TResolutionName | undefined {
  const currentWidth = width ?? (typeof window !== 'undefined' ? window.innerWidth : undefined);

  if (typeof currentWidth !== 'number') {
    return undefined;
  }

  let found: TResolutionName = RESOLUTION_STEPS[0].name;

  RESOLUTION_STEPS.forEach((step) => {
    if (currentWidth >= step.from) {
      found = step.name;
    }
  });

  return found;
}

export const isMobile = (resolution: string) => ['mobile_small', 'mobile_big'].includes(resolution);
export const isNotMobile = (resolution: string) =>
  !['mobile_small', 'mobile_big'].includes(resolution);
export const isTablet = (resolution: string) => ['tablet'].includes(resolution);
export const isDesktop = (resolution: string) =>
  ['desktop_small', 'desktop_big', 'hd'].includes(resolution);
export const isNotDesktop = (resolution: string) =>
  !['desktop_small', 'desktop_big', 'hd'].includes(resolution);
